import React, { useState, useEffect } from "react";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import { useNavigate } from "react-router";
import Grid from "@material-ui/core/Grid";
import Container from "@material-ui/core/Container";
import Select from "react-select";
import swal from "sweetalert";
import axios from "axios";
import { useSearchParams } from "react-router-dom";
import DateBox from "devextreme-react/date-box";
import { api_path } from "../../shared";
export function SaleActivityFormContent() {
  const navigate = useNavigate();
  const goBack = () => {
    navigate(-1);
  };

  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");
  const [getActivityName, setActivityName] = useState("");
  const [getCustomer, setCustomer] = useState([]);
  const [getCustomerList, setCustomerList] = useState([]);
  const [selectCustomer, setSelectCustomer] = useState([]);

  const [getStatus, setStatus] = useState([]);
  const [statusList, setStatusList] = useState([]);
  const [selectStatus, setSelectStatus] = useState([]);
  const [getActivityDate, setActivityDate] = useState("");
  const [getTimeSpending, setTimeSpending] = useState("");
  const [subjectName, setSubjectName] = useState("");
    const [remark, setRemark] = useState("");
  const now = new Date();
  const dateLabel = { "aria-label": "Date" };
  const onValueChanged = React.useCallback((e) => {
    console.log(e.value);
    setActivityDate(e.value);
  }, []);
  useEffect(() => {
    //run always
  });
  useEffect(() => {
    //run one time only
    fetchCustomer();
  }, []);
  useEffect(() => {
    //run when id Change value.
    if (id > 0) {
      setSubjectName("Edit Activity");
      fetch(api_path + "/TS_SALES_ACTIVITY.php?id=" + id)
        .then((res) => res.json())
        .then((res) => {
          const array = res;
          for (const i of array) {
            setActivityName(i.TOPIC);
            setActivityDate(i.ACTIVITY_DATE);
            setTimeSpending(i.TIME_SPENDING);
          }
        });
    } else {
      setSubjectName("New Activity");
    }
  }, [id]);
  const fetchCustomer = () => {
    axios
      .get(api_path + `/customer/customers.php`)
      .then((response) => {
        setCustomerList(response.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const handleCustomerChange = (obj) => {
    setSelectCustomer(obj.CRM_CUSCODE);
    setCustomer({
      CRM_CUSCODE: obj.CRM_CUSCODE,
      CUSTOMER_NAME: obj.CUSTOMER_NAME,
    });
  };
  const handleStatusChange = (obj) => {
    setSelectStatus(obj.PORT_CODE);
    setStatus({ PORT_CODE: obj.PORT_CODE, PORT_NAME: obj.PORT_CODE });
  };

  const handleSubmit = (event) => {
    let USERID = "kornraphat.c@sinologistics.co.th";
    event.preventDefault();
    let methodKey = "";
    if (id > 0) {
      methodKey = "PUT";
      var data = {
        BUSINESS_ID: selectCustomer,
        USERID: USERID,
      };
    } else {
      methodKey = "POST";
      var data = {
        BUSINESS_ID: selectCustomer,
        USERID: USERID,
      };
    }
    fetch(api_path + "/CT_QUOTATION.php", {
      method: methodKey,
      headers: {
        Accept: "application/form-data",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        if (result["status"] == "200") {
          swal("Done.", "Save data successfully.", "success", {
            buttons: true,
            timer: 1000,
          }).then(function () {
            //window.location = "./#/SaleInquiry?id=" + result["message"] + "&country_code=" +selectCountry;
          });
        } else {
          swal("Sorry", result["message"], "error", {
            buttons: true,
            timer: 1000,
          });
        }
      });
  };
  const optionsCustomer = [
    { value: "1", label: "Call" },
    { value: "2", label: "Email" },
    { value: "3", label: "Letter" },
    { value: "4", label: "Quote" },
    { value: "5", label: "Others" },
  ];
  const optionsType2 = [
    { value: "1", label: "Call" },
    { value: "2", label: "Email" },
    { value: "3", label: "Letter" },
    { value: "4", label: "Quote" },
    { value: "5", label: "Others" },
  ];
  const optionsType = [
    {
      value: 1,
      text: "Phone",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
        >
          <path
            fill="currentColor"
            d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.568 17.568 0 0 0 4.168 6.608a17.569 17.569 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.678.678 0 0 0-.58-.122l-2.19.547a1.745 1.745 0 0 1-1.657-.459L5.482 8.062a1.745 1.745 0 0 1-.46-1.657l.548-2.19a.678.678 0 0 0-.122-.58zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42a18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877z"
          />
        </svg>
      ),
    },
    {
      value: 2,
      text: "Email",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
        >
          <g fill="currentColor">
            <path d="M2 2a2 2 0 0 0-2 2v8.01A2 2 0 0 0 2 14h5.5a.5.5 0 0 0 0-1H2a1 1 0 0 1-.966-.741l5.64-3.471L8 9.583l7-4.2V8.5a.5.5 0 0 0 1 0V4a2 2 0 0 0-2-2zm3.708 6.208L1 11.105V5.383zM1 4.217V4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v.217l-7 4.2z" />
            <path d="M14.247 14.269c1.01 0 1.587-.857 1.587-2.025v-.21C15.834 10.43 14.64 9 12.52 9h-.035C10.42 9 9 10.36 9 12.432v.214C9 14.82 10.438 16 12.358 16h.044c.594 0 1.018-.074 1.237-.175v-.73c-.245.11-.673.18-1.18.18h-.044c-1.334 0-2.571-.788-2.571-2.655v-.157c0-1.657 1.058-2.724 2.64-2.724h.04c1.535 0 2.484 1.05 2.484 2.326v.118c0 .975-.324 1.39-.639 1.39c-.232 0-.41-.148-.41-.42v-2.19h-.906v.569h-.03c-.084-.298-.368-.63-.954-.63c-.778 0-1.259.555-1.259 1.4v.528c0 .892.49 1.434 1.26 1.434c.471 0 .896-.227 1.014-.643h.043c.118.42.617.648 1.12.648m-2.453-1.588v-.227c0-.546.227-.791.573-.791c.297 0 .572.192.572.708v.367c0 .573-.253.744-.564.744c-.354 0-.581-.215-.581-.8Z" />
          </g>
        </svg>
      ),
    },
    {
      value: 3,
      text: "Letter",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
        >
          <path
            fill="currentColor"
            d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v.217l7 4.2l7-4.2V4a1 1 0 0 0-1-1zm13 2.383l-4.708 2.825L15 11.105zm-.034 6.876l-5.64-3.471L8 9.583l-1.326-.795l-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741M1 11.105l4.708-2.897L1 5.383z"
          />
        </svg>
      ),
    },
    {
      value: 4,
      text: "Quote",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
        >
          <g fill="currentColor">
            <path d="M5 4a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1zm-.5 2.5A.5.5 0 0 1 5 6h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5M5 8a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1zm0 2a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1z" />
            <path d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2zm10-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1" />
          </g>
        </svg>
      ),
    },
  ];
  const options = [
    { value: "1", label: "NEW", color: "#9ed2ff" },
    { value: "2", label: "DONE", color: "#39BB5A" },
    { value: "3", label: "CANCEL", color: "#FF8B8B" },
  ];
  const colorStyles = {
    option: (styles, { data }) => {
      return {
        ...styles,
        backgroundColor: data.color,
      };
    },
  };
  const optionsContainer = [
    { value: "1", label: "20" },
    { value: "2", label: "40" },
    { value: "3", label: "40HQ" },
  ];
  return (
    <Container maxWidth="md">
      <Grid container>
            <Grid container spacing={2}>
       <br/><br/><br/>
        </Grid>
        <Grid container spacing={2}>
          <label className="head">{subjectName}</label>
        </Grid>
        <form onSubmit={handleSubmit}>
          <Grid container className="Box" spacing={2}>
        
            <Grid item xs={12} sm={6}>
              <label>Activity date</label>
              <DateBox
                defaultValue={now}
                inputAttr={dateLabel}
                type="date"
                displayFormat="dd/MM/yyyy"
                value={getActivityDate}
                onValueChanged={onValueChanged}
              />
              {/* <TextField
                size="small"
                name="getActivityDate"
                fullWidth
                id="getActivityDate"
                value={getActivityDate}
                onChange={(e) => setActivityDate(e.target.value)}
              /> */}
            </Grid>
            <Grid item xs={12} sm={6}>
              <label>Time Spending</label>
              <TextField
                size="small"
                name="getTimeSpending"
                variant="outlined"
                fullWidth
                id="getTimeSpending"
                value={getTimeSpending}
                onChange={(e) => setTimeSpending(e.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <label>Select Customer</label>
              <span className="red">*</span>
              <Select
                placeholder="Select Customer"
                value={getCustomer}
                options={getCustomerList}
                onChange={handleCustomerChange}
                getOptionLabel={(x) => x.CUSTOMER_NAME}
                getOptionValue={(x) => x.CRM_CUSCODE}
                required
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <label>Type of Activity</label>
              <span className="red">*</span>
              <Select
                placeholder="Select Status"
                options={optionsType}
                onChange={handleStatusChange}
                getOptionLabel={(e) => (
                  <div style={{ display: "flex", alignItems: "center" }}>
                    {e.icon}
                    <span style={{ marginLeft: 5 }}>{e.text}</span>
                  </div>
                )}
                required
              />
            </Grid>

                <Grid item xs={12} sm={12}>
              <label>Topic</label>
              <TextField
                size="small"
                name="getActivityName"
                variant="outlined"
                fullWidth
                id="getActivityName"
                value={getActivityName}
                onChange={(e) => setActivityName(e.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={12}>
        
        <label>Detail</label>
        <TextField
          size="small"
          name="remark"
          fullWidth
          id="remark"
          value={remark}
          onChange={(e) => setRemark(e.target.value)}
        />
      </Grid>
        <Grid item xs={12} sm={6}>
              <label>Reminder</label>
              <DateBox
                defaultValue={now}
                inputAttr={dateLabel}
                type="date"
                displayFormat="dd/MM/yyyy"
                value={getActivityDate}
                onValueChanged={onValueChanged}
              />
          
            </Grid>
              <Grid item xs={12} sm={6}></Grid>
                         <Grid item xs={12} sm={6}>
                              <label>Create by</label>
              <TextField
                size="small"
                name="getTimeSpending"
                variant="outlined"
                fullWidth
                id="getTimeSpending"
                value={getTimeSpending}
                onChange={(e) => setTimeSpending(e.target.value)}
              />
                         </Grid>
                                    <Grid item xs={12} sm={6}><label>Sales</label>
  
              <Select
                placeholder="Select Customer"
                value={getCustomer}
                options={getCustomerList}
                onChange={handleCustomerChange}
                getOptionLabel={(x) => x.CUSTOMER_NAME}
                getOptionValue={(x) => x.CRM_CUSCODE}
                required
              /></Grid>
           <Grid item xs={12} sm={12}>
        
        <label>Comment</label>
        <TextField
          size="small"
          name="remark"
          fullWidth
          id="remark"
          value={remark}
          onChange={(e) => setRemark(e.target.value)}
        />
      </Grid>
    
      <Grid item xs={12} sm={12}>
        
        <label>Leader Commment</label>
        <TextField
          size="small"
          name="remark"
          fullWidth
          id="remark"
          value={remark}
          onChange={(e) => setRemark(e.target.value)}
        />
      </Grid> 

            <br />
            <Grid container className="Box" spacing={2}>
              <Grid item xs={12} sm={6}>
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  color="primary"
                >
                  Save
                </Button>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Button
                  type="button"
                  fullWidth
                  variant="outlined"
                  color="primary"
                  onClick={goBack}
                >
                  &larr; Go Back
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </form>
      </Grid>
    </Container>
  );
}
